<template>
  <div class="swiper-card card-story">
    <div class="story-main">
      <div v-if="getCountry" class="country">
        <div class="map-icon">
          <img :src="'https://nourished.news/r/i/icons/country_flags/2020/svg/' + getCountry.name.toLowerCase().replace(/\s+/g, '-') + '.svg'" :alt="getCountry.name"/>
        </div>
        <span>{{ getCountry.name }}</span>
      </div>

      <h4 v-if="cardReconer" v-html="cardReconer"></h4>
      <h1>{{ slide.title }}</h1>

      <!-- <div v-if="isAlpha" class="content-block">
        <p>{{ getStoryContent.what }} {{ getStoryContent.why }}</p>
        <p class="content-tiny">{{ getStoryContent.andso }}</p>
      </div> -->
      
      <div xxxv-if="isAlpha" class="content-block card-markdown" v-html="getBodyContent"></div>

      <!-- <div v-else>
        <div v-for="(content, idx) in getBody" :key="idx" class="content-block">
          <h2 v-if="content.title">{{ content.title }}</h2>
          <h3>What's happening?</h3>
          <p v-html="getStoryContent.what"></p>
          <h3>Why now?</h3>
          <p v-html="getStoryContent.why"></p>
          <h3>What next?</h3>
          <p v-html="getStoryContent.andso"></p>
        </div>
      </div> -->
      
    </div>

    <div class="dive-wrap" v-if="getDeepDiveStories">
      <div class="dive-header">
        <h3>Read the full story</h3>
        <svg width="17" height="48" viewBox="0 0 17 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.99544 39.3715C3.3061 37.3956 2.94037 34.4772 0.0812931 32.4453C0.0812931 33.7307 -0.12194 34.4745 0.114274 35.0428C1.63819 38.7088 3.12477 42.4004 4.89337 45.9545C6.06775 48.3146 7.77517 48.6562 9.58405 46.8554C11.9463 44.5038 14.0699 41.8987 16.0898 39.2513C16.8633 38.2374 17.6219 36.8337 16.2068 35.2086C12.9838 36.631 12.004 40.2113 9.16645 42.3331C9.0691 41.672 8.9422 41.2851 8.96677 40.9077C9.47163 33.1737 8.89692 25.4835 8.14069 17.7892C7.68991 13.2026 7.53802 8.58842 7.18336 3.9918C7.10225 2.94057 6.86739 1.85701 6.45026 0.893604C6.25535 0.443527 5.47442 0.0465431 4.92669 0.00115967C4.56144 -0.0291634 3.89929 0.541996 3.78951 0.952045C3.51718 1.96854 3.31565 3.05786 3.38447 4.09898C3.86529 11.3721 4.44034 18.6391 4.94779 25.9106C5.25787 30.3544 5.50145 34.8026 5.77494 39.2488C5.5151 39.2897 5.25528 39.3306 4.99544 39.3715Z" fill="#FFDE00"/>
        </svg>
      </div>

      <!-- <div class="deep-story-stack">
        <div v-for="(story) in getDeepDiveStories" :key="`story-${story.slug}`" class="story" @click="goDeeper(story.type, story.slug)">
          <div v-if="story.image" :to="`/story/${story.slug}`" class="story-image">
            <div onerror="this.style.display='none'" class="inner-image">
              <img :src="story.image" :alt="story.name" />
            </div>   
          </div>

          <div class="story-content-wrapper">
            <div :to="`/story/${story.slug}`">
              <div class="story-content">
                <h2 v-if="story.name" class="story-name">{{ story.name }}</h2>
                <div class="story-meta-wrapper">
                  <span class="story-meta">
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.5938 7.5C13.5937 9.11616 12.9517 10.6661 11.8089 11.8089C10.6661 12.9517 9.11616 13.5938 7.5 13.5938C5.88384 13.5938 4.33387 12.9517 3.19107 11.8089C2.04827 10.6661 1.40625 9.11616 1.40625 7.5C1.40625 5.88384 2.04827 4.33387 3.19107 3.19107C4.33387 2.04827 5.88384 1.40625 7.5 1.40625C9.11616 1.40625 10.6661 2.04827 11.8089 3.19107C12.9517 4.33387 13.5937 5.88384 13.5938 7.5ZM0 7.5C0 9.48912 0.790176 11.3968 2.1967 12.8033C3.60322 14.2098 5.51088 15 7.5 15C9.48912 15 11.3968 14.2098 12.8033 12.8033C14.2098 11.3968 15 9.48912 15 7.5C15 5.51088 14.2098 3.60322 12.8033 2.1967C11.3968 0.790176 9.48912 0 7.5 0C5.51088 0 3.60322 0.790176 2.1967 2.1967C0.790176 3.60322 0 5.51088 0 7.5ZM6.79688 3.51562V7.5C6.79688 7.73438 6.91406 7.9541 7.11035 8.08594L9.92285 9.96094C10.2451 10.1777 10.6816 10.0898 10.8984 9.76465C11.1152 9.43945 11.0273 9.00586 10.7021 8.78906L8.20312 7.125V3.51562C8.20312 3.12598 7.88965 2.8125 7.5 2.8125C7.11035 2.8125 6.79688 3.12598 6.79688 3.51562Z" fill="black"/>
                    </svg>
                    {{ story.last_published_at | ago }}
                  </span>
                  <span class="story-meta">{{ story.meta.cx_pub }} sources</span>
                  <! -- <div class="item-mood" :class="getMood(story.mood).code">
                    <div class="item-mood-marker"></div>
                    <span>{{ getMood(story.mood).name }}</span>
                  </div> -- >
                </div>
                <span v-if="story.stack" class="story-stack">{{ story.stack }}</span>
                <span v-if="story.synopsis" class="story-stack">{{ story.synopsis }}</span>
              </div>
            </div>

            <ul class="meta" :title="story.last_published_at | date">
              <li v-for="(topic, idx) in story.topics.slice(0, 3)" :key="`story-${idx}-${story.slug}-topic-${topic.topic_code}`" @click.stop="$router.push(`/topic/${topic.topic_code}`)">
                {{ topic.topic_name }}
              </li>
            </ul>    
          </div>       
        </div>
      </div> -->

      <div class="deep-story" v-for="(story, idx) in getDeepDiveStories" :key="idx" @click="goDeeper(story.type, story.slug)">
        <div class="deep-stack">
          <h4>{{ story.name }}</h4>
          <div v-if="story.publisher" class="deep-publisher">
            <img v-if="story.publisher.icon" :src="story.publisher.icon" :alt="story.publisher.name" />
            <span>{{ story.publisher.name }}</span>
          </div>
        </div>
        <svg width="140" height="106" viewBox="0 0 140 106" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M138.072 58.1325C140.643 55.5613 140.643 51.4036 138.072 48.8597L92.1394 2.87838C89.5694 0.307143 85.4135 0.307143 82.8708 2.87838C80.3281 5.44961 80.3008 9.60734 82.8708 12.1512L117.594 46.8902H6.56186C2.9255 46.8902 0 49.817 0 53.4551C0 57.0931 2.9255 60.0199 6.56186 60.0199H117.594L82.8708 94.7589C80.3008 97.3301 80.3008 101.488 82.8708 104.032C85.4409 106.576 89.5967 106.603 92.1394 104.032L138.072 58.1325Z" fill="black"/>
        </svg>
      </div>

      <!-- <ul>
        <li v-for="story in getGoDeepStories" :key="`godeep-story-${story.slug}`" @click="goDeeper('story', story.slug);">
          + {{ story.name }}
        </li>
      </ul> -->
    </div>
  </div>
</template>

<script>
  import API from 'app/axios';
  import dayjs from 'dayjs'
  import relativeTime from 'dayjs/plugin/relativeTime'
  dayjs.extend(relativeTime)
  // import ReadLater from '@/components/v5/elements/ReadLater.vue'

  export default {
    data() {
      return {
        // imageOpacity: 1,
        // scrollParent: null,
        readState: 'skip',
        // isEnd: false,
        iTimeStart: 0,
      }
    },

    props: {
      slide: {
        type: Object,
      },
      meta: {
        type: Object
      },
      stack: {
        type: Object,
      },
      stories: {
        type: Array,
      },
      articles: {
        type: Array,
      },
    },

    components: {
      // ReadLater,
    },

    mounted() {
      // this.scrollParent = this.getScrollableParent(this.$el);
      // if (this.scrollParent) {
      //   this.scrollParent.addEventListener('scroll', this.handleScroll, { passive: true });
      //   this.handleScroll();
      // }
      this.iTimeStart = (new Date()).getTime();
      // this.observeEndCard();
    },

    // beforeDestroy() {
    //   if (this.scrollParent) {
    //     this.scrollParent.removeEventListener('scroll', this.handleScroll);
    //   }
    // },

    computed: {
      isAlpha() {
        return this.$store.getters.isAlpha;
      },

      cardReconer() {
        if (this.stack.slug == 'five-a-day') {
          let sType = Object.values(this.slide?.meta?.extra || {})?.[0]?.card;
          switch (sType) {
            case "domestic": return 'Something national'; // return 'Here at home…'; 
            case "international": return 'Something international'; // return '… and abroad.';
            case "intriguing": return 'Something interesting'; // return 'Surprisingly…';
            case "wildcard": return 'Something different'; // return 'Have you heard…';
            case "inspiring": return 'Something postitve'; // return 'In better news…';
            default: return false;
          }
        }
        return false;
      },

      getCountry() {
        if (this.stack.type !== 'geo') { return false; }

        if (this.slide.meta?.locales?.length > 0) {
          return this.slide.meta.locales[0];
        }

        return false
      },

      getDeepDiveStories() {
        // return {extra: this.slide?.meta?.extra, stories: this.slide?.meta?.stories};
        // console.log(` ---------------- `, this.stories);
        const stories = this.stories?.filter(s => {
          return this.slide?.meta?.stories?.includes(s.slug);
        });

        if (stories.length > 0) {
          stories.forEach(story => {
            story.type = 'story'
          })
          return stories;
        }
        
        // grap the article slugs from the meta data (`arx_aaaaaaaaaaa`)
        let aArticleSlugs = Object.keys(this.slide?.meta?.extra).filter(s => /^arx_/.test(s)).map(s => s.replace(/^arx_/, ''));


        let aArticles = this.articles.filter(a => aArticleSlugs.includes(a.slug));

        if (aArticles.length > 0) {
          aArticles = aArticles.map(article => ({ // So we can keep the same loop (slug is the article because we need it for handling in GoDeeper but keeping the loop logic the same)
            type: 'article',
            name: article.name,
            slug: article.slug,
            publisher: article.publisher
          }))
          // console.log(`foo: `, aArticleSlugs, this.articles, aArticles) // @Jim: Passing articles here now
          return aArticles;
        }

        return null
      },

      getStoryContent() {
        return this.slide?.meta?.script;
      },

      getBody() {
        const body = [...this.slide.content.body];
        const image = this.images[1];

        if (body.length > 0 && typeof body[0].content === 'string' && image) {
          let imageHTML = `
            <div class="image">
              <img src="${image.image}" alt="${image.caption}" />
              <p class="caption">${image.caption}</p>
            </div>`;

          body[0] = {
            ...body[0],
            content: body[0].content.replace(/(<([a-z][a-z0-9]*)[^>]*>)(.*?)(<\/\2>)/s, (match, p1, p2, p3, p4) => `${p1}${p3}${p4}${imageHTML}`)
          };
        }

        // console.log(`BODY: `, body);

        return body;
      },

      getBodyContent() {
        const body = [...this.slide.content.body];
        return body?.[0]?.content;
      },

      images () {
        let images = [];
        this.slide?.meta?.stories?.forEach(slug => {
          this.$store.getters.getStory(slug)?.articles?.forEach(article => {
            images.push({
              story: slug,
              article: article.slug,
              image: article.image,
              photo: article.photo,
              publisher: article.publisher,
              caption: article.name,
            });
          });
        });

        // it's nonsense but it's deterministic (so it doesn't jitter -- speak to Jim)
        // *** it's also the oposite sort order to the stack (so should always be different image)
        return images.filter(a => a.photo).sort((a, b) => {
          if (a.story == b.story) {
            return a.article > b.article ? 1 : -1;
          }
          return a.story > b.story ? 1 : -1;
        });

        // return images.filter(a => a.photo).sort( () => .5 - Math.random() );
      },


      // bioObject() {
      //   // okay - for now, assume just the first story (should't be to in biography context)
      //   let sSlug = this.slide?.meta?.stories?.[0];
      //   if (!sSlug) {
      //     return {};
      //   }
      //   // get out "who" object (contains the name + wiki slug)
      //   let oWho = this.slide?.meta?.extra?.[sSlug]?.who;
      //   if (!oWho) {
      //     return {};
      //   }
      //   // find the story this is coming from ...
      //   let oStory = this.stories.filter((o) => {
      //     return o.slug == sSlug;
      //   }).shift();
      //   if (!oStory) {
      //     console.log(`No Story!? `, oStory);
      //     return {};
      //   }
      //   // now find the topic card (which we can assume is present in the story! :fingers_crossed:)
      //   let oTopic = oStory?.topics?.filter((t) => {
      //     // okay ... actually got topic_codes (which wasn't the expection... and probably unhelpful)
      //     // expect the API to change here slightly so ... here are a few catches (the middle one *should* be the charm)
      //     return (t.topic_code == oWho.wiki) || (t.meta_wiki == oWho.wiki) || (t.meta_wiki == `/wiki/${oWho.wiki}`);
      //   }).shift();
      //   console.log(`Topic: `, oTopic);
      //   return oTopic;
      // },

      // bioMeta() {
      //   return this.bioObject?.meta || {};
      // },

      // featured() {
      //   return this.images[0];
      // },

      // backgroundStyle() {
      //   let img = this.featured?.image;
      //   return {
      //     backgroundImage: `url('${img}')`,
      //     opacity: this.imageOpacity,
      //     transform: `translateY(-${(1 - this.imageOpacity) * 100}px)`
      //   };
      // },

      // getFurtherReading() {
      //   let stories = [];

      //   this.slide?.stories.forEach((slug) => {
      //     let story = this.$store.getters.getStory(slug);
      //     stories.push(story)
      //   })

      //   return stories
      // },

      // timeline() {
      //   return this.slide?.content?.timeline || []; 
      // },
    },

    methods: {
      next() {
        // this.tmpCommitTracking();
        this.$emit('next');
        this.readState = 'skip';
        // this.isEnd = false;
      },

      goDeeper(sMode, sSlug) {
        // console.log('ARTICLE GO', sMode, sSlug)

        if (sMode === 'story') {
          let oStory = this.stories?.find(o => o.slug == sSlug);
          let sNode = oStory?.clusters?.timeseries?.[0]?.links?.[0];
          // console.warn(`GoDeeper [${sMode}] + [${sSlug}] -- Node = ${sNode}`);

          if (!sNode) {
            console.warn(`GoDeeper [${sMode}] - Weird? No node?...`);
            return;
          }

          // not sure we need this -- but since there's no nav yet, probably our responsibility
          API.getStoryV3(sSlug);
          API.getStoryNodeV3(sSlug, sNode);

          this.$dataEngine.forceStoryNav({
            slug: sSlug,
            node: sNode,
          });

          this.EventBus.$emit('layer:new', {
            'component': 'story',
            'opts': {
              context: 'stack',
              slug: sSlug,
              node: sNode,
            },
            'onClose': () => {
              // console.log(`\x1b[36m[LAYER] -- CLOSE CALLBACK! (Story)`);
              this.$dataEngine.forceStoryNav({});
            }
          });
        }

        if (sMode === 'article') {
          console.log('I AM ARTICLE', sSlug)
          this.EventBus.$emit('layer:new', {
            'component': 'legacy-article',
            'opts': {
              context: 'stack',
              slug: sSlug,
            },
            'onClose': () => {
              // console.log(`\x1b[36m[LAYER] -- CLOSE CALLBACK! (Article)`);
              // this.$dataEngine.forceStoryNav({});
            }
          });

          // console.log('URL', sSlug)
          // this.EventBus.$emit("didSelectArticle", {
          //   src: this,
          //   article: sSlug,
          //   story: '-',
          // });
        }
      },

      // tmpCommitTracking() {
      //   let oPayload = this.$userEngine.getSyncPayloadTemplate();
      //   // okay, clear out..
      //   delete oPayload.story;
      //   delete oPayload.article;
      //   // and fill in..
      //   oPayload.feature = this.stack.slug.replace(/pattern:/, '');
      //   oPayload.card = this.slide.slug;
      //   // time?
      //   oPayload.time = Math.ceil(((new Date()).getTime() - this.iTimeStart) / 1000);
      //   oPayload.state = 'read';
      //   console.log(oPayload, this.slide);
      //   this.$userEngine.pushSync(oPayload);
      // },
      
      // furtherStory(slug) {
      //   this.$router.push(`/story/${slug}`)
      //   document.body.style.overflow = 'unset';
      // },

      timeAgo(date) {
        return dayjs().to(dayjs(date));
      },

      // getScrollableParent(el) {
      //   let parent = el.parentNode;
      //   while (parent && parent !== document.body) {
      //     const style = window.getComputedStyle(parent);
      //     const overflowY = style.overflowY;
      //     if (overflowY === 'auto' || overflowY === 'scroll') {
      //       return parent;
      //     }
      //     parent = parent.parentNode;
      //   }
      //   return null;
      // },

      // handleScroll() {
      //   if (!this.scrollParent) return;
      //   const scrollTop = this.scrollParent.scrollTop;
      //   const fadeStart = 0;
      //   const fadeEnd = 200;

      //   let opacity = 1;
      //   if (scrollTop <= fadeStart) {
      //     opacity = 1;
      //   } else if (scrollTop >= fadeEnd) {
      //     opacity = 0;
      //   } else {
      //     opacity = 1 - (scrollTop - fadeStart) / (fadeEnd - fadeStart);
      //   }

      //   this.imageOpacity = opacity;
      //   this.$emit('opacity', opacity);
      // },

      // observeEndCard() {
      //   const endCardElement = this.$refs.endCard;
      //   if (endCardElement) {
      //     const observer = new IntersectionObserver(
      //       (entries) => {
      //         entries.forEach((entry) => {
      //           if (entry.isIntersecting) {
      //             this.tmpCommitTracking();
      //             this.readState = 'read';
      //             this.isEnd = true;
      //           } else {
      //             this.isEnd = false;
      //           }
      //         });
      //       },
      //       { threshold: 1.0 }
      //     );
      //     observer.observe(endCardElement);
      //   }
      // },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-story { 
    z-index: 999999999;
    position: relative;
    gap: 2rem;

    .desktop & {
      padding: 0 4rem 4rem 4rem;
    }

    h1 {
      margin-bottom: 1.5rem;
      font-size: 2.5rem;
      
      .desktop & {
        font-size: 4rem;
      }
    }

    h4 {
      font-size: 0.8rem;
      font-weight: bold;
      margin-bottom: 1.2rem;
      background: rgba($yellow-tone-3, 1);
      color: #000;
      align-self: flex-start;
      padding: 0.35rem 1rem 0.45rem 1rem;
      border-radius: 500px;
    }

    .country {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
      margin-bottom: 1.5rem;

      .map-icon {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 500px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 500px;
          object-fit: cover;
        }
      }
    }
  }

  .markdown ::v-deep {
    li {
      margin-top: 1em;
    }
  }

  .card-markdown ::v-deep {
    ul {
      margin-left: 1em;
      margin-bottom: 1em;
      li {
        padding-left: .5em;
        
        &:not(:last-child) {
          margin-bottom: 0.5rem;
        }

        &:last-child {
          margin-bottom: 1.5rem;
        }

        &::before {
          content: url('~@assets/images/inline-arrow.svg'); 
          color: $yellow-tone-3;
          display: inline-block; 
          width: 1.25em;
          margin-left: -1.25em;
        }
      }
    }
    p {
      margin-bottom: .5em;
      font-size: 1.1rem;
      line-height: 1.8em;
    }
    strong {
      font-family: inherit !important;
      font-size: inherit !important;
    }
  }

  .end-btn {
    // position: sticky;
    bottom: 1rem;
    right: 1rem;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      border-radius: 500px;
      padding: 1.2rem 1.5rem;
      font-size: 18px;
      font-weight: normal;
      margin-left: auto;
      transition: width 0.3s ease-in-out;
      backdrop-filter: blur(2px);
      color: $neutral-100;
      background: rgba($neutral-600, 0.75);
      border: 1px solid $neutral-400;

      .darkmode & {
        color: $neutral-600;
        background: rgba(11, 13, 14, 0.75);
        border: 1px solid $neutral-600;
      }

      svg {
        margin-left: 0.5rem;

        path {
          fill: $neutral-100;

          .darkmode & {
            fill: $neutral-600;
          }
        }
      }

      &.end {
        width: 100%;
      }

      &.read {
        border: 1px solid $green-tone-3;;
        color: $green-tone-3;

        svg path {
          fill: $green-tone-3;
        }
      }
    }
  }

  .end-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
    padding: 1.5rem;

    p {
      text-align: center;
      margin: 0.5rem 0;
    }

    h3 {
      margin-top: 0.5rem;
      font-size: 16px;
    }

    svg path {
      fill: $neutral-100;

      .darkmode & {
        fill: $neutral-600;
      }
    }

    &.read {
      h3 {
        color: $green-tone-3;
      }

      svg path {
        fill: $green-tone-3;
      }
    }
  }

  .story-image {
    width: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 10px;
    }
  }

  .dive-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    padding-bottom: 2rem;

    .desktop & {
      margin-top: 1rem;
    }

    h3 {
      font-family: 'Circular';
      font-weight: normal;
      font-size: 1.1rem;
      margin-bottom: 0.5rem;
    }

    .dive-header {
      display: flex;
      flex-direction: column;
      // flex-direction: row;
      // gap: 0.5em;

      align-items: center;
      width: 100%;
      margin-bottom: 1rem;

      svg {
        height: 2rem;
      }

      // .desktop & {
      //   max-width: 20rem;
      // }

      h3 {
        font-family: 'Circular';
        font-weight: bold;
        font-size: 1rem;
        // color: $yellow-tone-4;
        color: $neutral-300;
        transform: rotate(-5deg);

        .darkmode & {
          color: $yellow-tone-3;
        }
      }
    }

    .deep-story-stack {
      max-width: 20rem;
    }

    .deep-story {
      display: flex;
      align-items: center;
      padding: 1rem 1.2rem;
      width: 100%;
      border-radius: 15px;
      background: rgba($neutral-400, 0.1);
      gap: 2rem;
      transition: all 0.2s ease-in-out;
      cursor: pointer;

      &:hover {
        background: rgba($neutral-400, 0.2);
      }

      .deep-stack {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        flex: 1;

        .deep-publisher {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.8rem;
          color: $neutral-400;

          img {
            width: 1.2rem;
            height: 1.2rem;
            object-fit: cover;
            border-radius: 500px;
          }
        }
      }

      svg {
        height: 1rem;
        width: 1rem;

        path {
          fill: $neutral-100;

          .darkmode & {
            fill: $neutral-600;
          }
        }
      }

      h4 {
        background: none;
        font-weight: bold;
        padding: 0;
        margin: 0;
        font-size: 0.9rem;
        color: $neutral-100;
        flex: 1;

        .darkmode & {
          color: $neutral-600;
        }
      }
    }
  }

  .deep-story-stack {
    .story-content-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
    }

    .story {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      background: rgba($neutral-400, 0.05);
      border-radius: 10px;
      color: $neutral-100;
      border-left: 2px solid transparent;
      cursor: pointer;
      transition: all 0.2s ease-in-out;

      .darkmode & {
        color: $neutral-600;
      }

      &:hover {
        background: rgba($neutral-400, 0.15);
      }

      .story-image {
        width: 100%;
      }

      .inner-image {
        width: 100%;
        height: 10rem;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
      }

      .story-content {
        display: flex;
        flex-direction: column;
        gap: 0.4rem;
        flex: 1;
        padding: 1.5rem 1rem 1rem 1rem;

        .story-meta-wrapper {
          display: flex;
          align-items: center;
          margin-bottom: 0.25rem;

          .story-meta {
            display: flex;
            align-items: center;
            font-size: 0.8rem;
            color: $neutral-400;

            svg {
              margin-top: 1px;
              margin-right: 0.2rem;
              
              path {
                fill: $neutral-400;
              }
            }

            &:not(:last-child) {
              &::after{
                content: '|';
                margin: 0 0.4rem;
                color: $neutral-400;
              }
            }
          }
        }

        .story-name {
          font-size: 1.1rem;
          line-height: 140%;
        }

        .story-meta {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          font-size: 0.8rem;
          color: $neutral-400;
          margin-bottom: 0.25rem;

          svg {
            margin-top: 1px;
            
            path {
              fill: $neutral-400;
            }
          }
        }

        .item-mood {
          display: flex;
          align-items: center;
          gap: 0.3rem;
          background: none;
          padding-bottom: 2px;

          .item-mood-marker {
            width: 7px;
            height: 7px;
            border-radius: 500px;
          }

          span {
            display: inline-block;
            font-size: 0.8rem;
            color: $neutral-400;
            padding-bottom: 1px;
          }

          &.positive {
            color: $green-tone-3;
            .item-mood-marker {
              background: $green-tone-3;
            }
          }

          &.neutral {
            color: $blue-tone-3;
            .item-mood-marker {
              background: $blue-tone-3;
            }
          }

          &.negative {
            color: $red-tone-3;
            .item-mood-marker {
              background: $red-tone-3;
            }
          }
        }

        .story-stack {
          font-size: 0.8rem;
          color: $neutral-400;
          line-height: 140%;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }

      .meta {
        display: flex;
        flex-wrap: wrap;
        font-size: 0.8rem;
        gap: 0.5rem;
        padding: 1rem 1rem 1.5rem 1rem;

        li {
          color: $neutral-400;
          border-bottom: 1px solid $neutral-400;
          padding-bottom: 2px;
          transition: all 0.2s ease-in-out;

          &:hover {
            color: $neutral-100;
            border-bottom: 1px solid $neutral-100;

            .darkmode & {
              color: $neutral-600;
              border-bottom: 1px solid $neutral-600;
            }
          }
        }
      }
    }
  }

  .story-main {
    display: flex;
    flex-direction: column;

    .desktop & {
      gap: 1rem;
    }
  }
</style>